import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-about-background bg-top pb-20 bg-[length:130rem] h-full bg-no-repeat bg-white pt-28" }
const _hoisted_2 = { class: "mx-auto max-w-4xl" }
const _hoisted_3 = { class: "mb-6 flex flex-col gap-2" }
const _hoisted_4 = { class: "flex items-center gap-2 text-sm font-medium text-gray-500" }
const _hoisted_5 = { class: "p-6 bg-white border border-slate-200 shadow-sm rounded-2xl" }
const _hoisted_6 = { class: "mb-6" }
const _hoisted_7 = { class: "mb-6" }
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = { class: "mb-6" }
const _hoisted_10 = { class: "mb-6" }
const _hoisted_11 = { class: "mb-6" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "border-t border-gray-200 pt-6" }
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = { class: "flex items-center justify-between gap-4" }
const _hoisted_16 = { class: "mb-2" }
const _hoisted_17 = { class: "flex items-center justify-between gap-4" }
const _hoisted_18 = { class: "mt-8" }
const _hoisted_19 = { class: "mb-2" }
const _hoisted_20 = { class: "flex items-center justify-between gap-4" }
const _hoisted_21 = { class: "mb-2" }
const _hoisted_22 = { class: "flex items-center justify-between gap-4" }
const _hoisted_23 = { class: "border-t border-gray-200 pt-6 mt-8" }
const _hoisted_24 = { class: "mt-8" }
const _hoisted_25 = { class: "grid gap-6 md:grid-cols-2" }
const _hoisted_26 = { class: "md:col-span-2" }
const _hoisted_27 = { class: "grid gap-3 md:grid-cols-2" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "md:col-span-2" }
const _hoisted_30 = { class: "flex flex-wrap gap-4" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "mt-8" }
const _hoisted_33 = { class: "grid gap-6 mb-6 md:grid-cols-2" }
const _hoisted_34 = { class: "mt-8 flex flex-wrap items-center gap-3" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 0,
  class: "text-sm text-gray-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cog6ToothIcon = _resolveComponent("Cog6ToothIcon")!
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Cog6ToothIcon, { class: "h-4 w-4 text-primary" }),
          _cache[17] || (_cache[17] = _createTextVNode(" Settings "))
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "text-3xl font-semibold text-gray-900" }, " Profile Settings ", -1)),
        _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-gray-600" }, " Update your personal details and preferences. ", -1))
      ]),
      _cache[37] || (_cache[37] = _createStaticVNode("<nav aria-label=\"Breadcrumb\" class=\"flex mb-3 justify-between\"><ol class=\"inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse\"><li class=\"inline-flex items-center\"><a class=\"inline-flex items-center text-sm font-medium text-gray-700 hover:text-primary\" href=\"#\"> Dashboard </a></li><li><div class=\"flex items-center\"><svg aria-hidden=\"true\" class=\"rtl:rotate-180 w-3 h-3 text-gray-400 mx-1\" fill=\"none\" viewBox=\"0 0 6 10\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m1 9 4-4-4-4\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path></svg><a class=\"ms-1 text-sm font-medium text-black hover:text-primary md:ms-2\" href=\"#\">My Account</a></div></li><li><div class=\"flex items-center\"><svg aria-hidden=\"true\" class=\"rtl:rotate-180 w-3 h-3 text-gray-400 mx-1\" fill=\"none\" viewBox=\"0 0 6 10\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m1 9 4-4-4-4\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"></path></svg><a class=\"ms-1 text-sm font-medium text-black hover:text-primary md:ms-2\" href=\"#\">Settings</a></div></li></ol></nav>", 1)),
      _createElementVNode("div", _hoisted_5, [
        _cache[35] || (_cache[35] = _createStaticVNode("<div class=\"flex justify-between\"><h2 class=\"text-sm text-gray-800\"> Personal Details </h2></div><div class=\"flex items-center justify-between mt-2 mb-6\"><div class=\"\"><div class=\"text-xl text-gray-900\"> Profile photo </div><div class=\"text-sm text-gray-500\"> Recommended size: 300 x 300 </div></div><div><a class=\"inline-flex justify-center items-center py-2 px-4 text-xs font-semibold text-gray-900 rounded-full bg-primary hover:bg-[#c9ad99]\" href=\"#\"><svg class=\"mr-1 -ml-1 w-4 h-4\" fill=\"currentColor\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path clip-rule=\"evenodd\" d=\"M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z\" fill-rule=\"evenodd\"></path></svg> Upload Image </a></div></div>", 2)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_TextInput, {
            id: "fullName",
            modelValue: _ctx.fullName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fullName) = $event)),
            label: "Full Name"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_TextInput, {
            id: "company",
            modelValue: _ctx.company,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.company) = $event)),
            label: "Company Name"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_TextInput, {
            id: "phoneNumber",
            modelValue: _ctx.phoneNumber,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phoneNumber) = $event)),
            label: "Phone Number"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_TextInput, {
            id: "linkedinUrl",
            modelValue: _ctx.linkedinUrl,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.linkedinUrl) = $event)),
            label: "LinkedIn URL",
            placeholder: "https://www.linkedin.com/in/username"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_TextInput, {
            id: "xUrl",
            modelValue: _ctx.xUrl,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.xUrl) = $event)),
            label: "X (Twitter) URL",
            placeholder: "https://x.com/username"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[21] || (_cache[21] = _createElementVNode("label", {
            class: "block text-sm font-medium text-gray-700 mb-2",
            for: "timeZone"
          }, " Time Zone ", -1)),
          _withDirectives(_createElementVNode("select", {
            id: "timeZone",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.timeZone) = $event)),
            class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary"
          }, [
            _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, " Select time zone ", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeZones, (tz) => {
              return (_openBlock(), _createElementBlock("option", {
                key: tz,
                value: tz
              }, _toDisplayString(tz), 9, _hoisted_12))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.timeZone]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, [
              _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-sm font-medium text-gray-700" }, "Show my profile in the member directory", -1)),
              _createElementVNode("button", {
                class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full border border-gray-300 transition", _ctx.user!.profileVisibility ? 'bg-primary' : 'bg-white']),
                type: "button",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.user!.profileVisibility = !_ctx.user!.profileVisibility))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-block h-5 w-5 transform rounded-full bg-white shadow transition", _ctx.user!.profileVisibility ? 'translate-x-5 border border-[#c9ad99]' : 'translate-x-[2px] border border-gray-300'])
                }, null, 2)
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, [
              _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-sm font-medium text-gray-700" }, "Make my email public", -1)),
              _createElementVNode("button", {
                class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full border border-gray-300 transition", _ctx.user!.emailVisibility ? 'bg-primary' : 'bg-white']),
                type: "button",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.user!.emailVisibility = !_ctx.user!.emailVisibility))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-block h-5 w-5 transform rounded-full bg-white shadow transition", _ctx.user!.emailVisibility ? 'translate-x-5 border border-[#c9ad99]' : 'translate-x-[2px] border border-gray-300'])
                }, null, 2)
              ], 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[26] || (_cache[26] = _createElementVNode("h2", { class: "text-md text-gray-800 mb-2" }, " Notifications ", -1)),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, [
              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-sm font-medium text-gray-700" }, "Send me email notifications", -1)),
              _createElementVNode("button", {
                class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full border border-gray-300 transition", _ctx.user!.emailNotifications ? 'bg-primary' : 'bg-white']),
                type: "button",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.user!.emailNotifications = !_ctx.user!.emailNotifications))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-block h-5 w-5 transform rounded-full bg-white shadow transition", _ctx.user!.emailNotifications ? 'translate-x-5 border border-[#c9ad99]' : 'translate-x-[2px] border border-gray-300'])
                }, null, 2)
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("label", _hoisted_22, [
              _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-sm font-medium text-gray-700" }, "Notify me about new course content", -1)),
              _createElementVNode("button", {
                class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full border border-gray-300 transition", _ctx.user!.courseContentNotifications ? 'bg-primary' : 'bg-white']),
                type: "button",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.user!.courseContentNotifications = !_ctx.user!.courseContentNotifications))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-block h-5 w-5 transform rounded-full bg-white shadow transition", _ctx.user!.courseContentNotifications ? 'translate-x-5 border border-[#c9ad99]' : 'translate-x-[2px] border border-gray-300'])
                }, null, 2)
              ], 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _cache[29] || (_cache[29] = _createElementVNode("h2", { class: "text-md text-gray-800 mb-2" }, " Setup Preferences ", -1)),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-3" }, " Which VNTR offerings appeal to you? * ", -1)),
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offeringsOptions, (option) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: option,
                      class: "flex items-center gap-2 text-sm text-gray-700"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedOfferings) = $event)),
                        class: "h-4 w-4 rounded border-gray-300",
                        type: "checkbox",
                        value: option
                      }, null, 8, _hoisted_28), [
                        [_vModelCheckbox, _ctx.selectedOfferings]
                      ]),
                      _createTextVNode(" " + _toDisplayString(option), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-3" }, " How would you describe yourself? * ", -1)),
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personaOptions, (option) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: option,
                      class: "flex items-center gap-2 text-sm text-gray-700"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.persona) = $event)),
                        class: "h-4 w-4 border-gray-300",
                        type: "radio",
                        value: option
                      }, null, 8, _hoisted_31), [
                        [_vModelRadio, _ctx.persona]
                      ]),
                      _createTextVNode(" " + _toDisplayString(option), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _cache[34] || (_cache[34] = _createElementVNode("h2", { class: "text-md text-gray-800 mb-2" }, " Account Security ", -1)),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", null, [
              _cache[30] || (_cache[30] = _createElementVNode("label", {
                class: "block mb-2 text-sm font-medium text-gray-700",
                for: "email"
              }, "Email", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "email",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.email) = $event)),
                class: "bg-white border border-gray-300 text-gray-900 text-sm focus:ring-primary focus:border-primary block w-full p-2.5",
                placeholder: "john.doe@company.com",
                required: "",
                type: "email"
              }, null, 512), [
                [_vModelText, _ctx.email]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[31] || (_cache[31] = _createElementVNode("label", {
                class: "block mb-2 text-sm font-medium text-gray-700",
                for: "current-password"
              }, "Current Password", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "current-password",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.user!.password) = $event)),
                class: "bg-white border border-gray-300 text-gray-900 text-sm focus:ring-primary focus:border-primary block w-full p-2.5",
                placeholder: "•••••••••",
                required: "",
                type: "password"
              }, null, 512), [
                [_vModelText, _ctx.user!.password]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[32] || (_cache[32] = _createElementVNode("label", {
                class: "block mb-2 text-sm font-medium text-gray-700",
                for: "new-password"
              }, "New Password", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "new-password",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.user!.newPassword) = $event)),
                class: "bg-white border border-gray-300 text-gray-900 text-sm focus:ring-primary focus:border-primary block w-full p-2.5",
                placeholder: "•••••••••",
                required: "",
                type: "password"
              }, null, 512), [
                [_vModelText, _ctx.user!.newPassword]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[33] || (_cache[33] = _createElementVNode("label", {
                class: "block mb-2 text-sm font-medium text-gray-700",
                for: "confirm-password"
              }, "Confirm Password", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "confirm-password",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.user!.confirmPassword) = $event)),
                class: "bg-white border border-gray-300 text-gray-900 text-sm focus:ring-primary focus:border-primary block w-full p-2.5",
                placeholder: "•••••••••",
                required: "",
                type: "password"
              }, null, 512), [
                [_vModelText, _ctx.user!.confirmPassword]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("button", {
            class: "inline-flex items-center justify-center rounded-full bg-primary px-6 py-2 text-sm font-semibold text-black hover:bg-[#c9ad99]",
            type: "button",
            disabled: _ctx.saving,
            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.saveProfile && _ctx.saveProfile(...args)))
          }, " Save Changes ", 8, _hoisted_35),
          (_ctx.saveMessage)
            ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.saveMessage), 1))
            : _createCommentVNode("", true)
        ]),
        _cache[36] || (_cache[36] = _createStaticVNode("<div class=\"mt-10 border-t border-gray-200 pt-6 grid\"><h2 class=\"text-xl text-gray-900 mb-2 font-medium\"> Deactivate My Account </h2><span class=\"text-gray-600 font-light\">Warning: this action permanently deactivates your account and removes access to this community.</span><a class=\"inline-flex justify-center items-center py-3 px-4 mt-3 w-52 text-xs font-medium text-center text-gray-900 rounded-full border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100\" href=\"#\"><svg class=\"mr-1 -ml-1 w-5 h-5\" fill=\"currentColor\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path clip-rule=\"evenodd\" d=\"M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z\" fill-rule=\"evenodd\"></path></svg> Deactivate My Account </a></div>", 1))
      ])
    ])
  ]))
}